











































import { defineComponent, onBeforeMount, reactive, toRefs } from '@vue/composition-api';
import { ServiceFactory } from '@/service/ServiceFactory';
import { useStore } from '@/utils/use-store';
import HomeworkForm from "@/components/Homework/HomeworkForm.vue";

import CommonTable from '@/components/CommonTable.vue';
import {Homework} from "@/helpers/types";

const HomeworkService = ServiceFactory.get('homework');

export default defineComponent({
  name: 'HomeworkList',

  components: {
    CommonTable,
    HomeworkForm
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    }
  },

  setup() {
    const store = useStore();
    const { accessToken: token } = store.state.user;

    const {
      homeworkList,
      fetchHomework,
      editHomework,
      createHomework,
      closeHomeworkDrawer,
      homeworkDrawer,
      homeworkToEdit,
      mode,
      removeExerciseHandler
    } = useHomework(token);

    async function beforeMountEventHandler() {
      try {
        await fetchHomework();
      } catch (e) {
        console.error(e);
      }
    }

    onBeforeMount(beforeMountEventHandler);

    return {
      homeworkList,
      editHomework,
      createHomework,
      closeHomeworkDrawer,
      homeworkDrawer,
      homeworkToEdit,
      mode,
      fetchHomework,
      removeExerciseHandler
    };
  }
});

function useHomework(token:string) {
  const homeworkState = reactive({
    homeworkList: [],
    homeworkDrawer: false,
    homeworkToEdit: {} as Homework,
    tempHomework: {},
    mode: ''
  });

  async function fetchHomework() {
    const { data } = await HomeworkService.list(token);
    homeworkState.homeworkList = data;
  }

  function editHomework(homeworkToEdit:any) {
    homeworkState.homeworkToEdit = homeworkToEdit;
    homeworkState.homeworkDrawer = true;
    homeworkState.mode = 'edit';
  }

  function createHomework() {
    homeworkState.homeworkToEdit = {} as Homework;
    homeworkState.homeworkDrawer = true;
    homeworkState.mode = 'create';
  }

  function closeHomeworkDrawer() {
    homeworkState.homeworkDrawer = false
  }

  function removeExerciseHandler(id:string) {
    homeworkState.homeworkToEdit.exercise = homeworkState.homeworkToEdit.exercise.filter((item) => item.id !== id);
  }

  return {
    ...toRefs(homeworkState),
    fetchHomework,
    editHomework,
    createHomework,
    closeHomeworkDrawer,
    removeExerciseHandler
  }
}

